import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useOwnerCurrency = () => {
  return useQuery({
    queryKey: ["ownerCurrency"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      const { data: ownerData, error: ownerError } = await supabase
        .from("owner_data")
        .select("currency")
        .eq("owner_id", user.id)
        .single();

      if (ownerError) throw ownerError;

      const { data: currencyData, error: currencyError } = await supabase
        .from("currencies")
        .select("symbol")
        .eq("code", ownerData?.currency)
        .single();

      if (currencyError) {
        console.warn("Currency symbol not found, using code:", ownerData?.currency);
        return ownerData?.currency || "FCFA";
      }

      return currencyData?.symbol || ownerData?.currency || "FCFA";
    },
  });
};